import React from "react";

const SvgQuestion = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 8 10"
    fill="none"
  >
    <path
      d="M3.65696 6.27273H4.81605L5.78764 7.55114L6.04332 7.89205L7.49219 9.81818H6.3331L5.37855 8.53977L5.13991 8.21591L3.65696 6.27273ZM7.85014 4.63636C7.85014 5.55682 7.68395 6.35227 7.35156 7.02273C7.01918 7.69318 6.56321 8.21023 5.98367 8.57386C5.40412 8.9375 4.74219 9.11932 3.99787 9.11932C3.25355 9.11932 2.59162 8.9375 2.01207 8.57386C1.43253 8.21023 0.976563 7.69318 0.644176 7.02273C0.31179 6.35227 0.145597 5.55682 0.145597 4.63636C0.145597 3.71591 0.31179 2.92045 0.644176 2.25C0.976563 1.57955 1.43253 1.0625 2.01207 0.698864C2.59162 0.335227 3.25355 0.153409 3.99787 0.153409C4.74219 0.153409 5.40412 0.335227 5.98367 0.698864C6.56321 1.0625 7.01918 1.57955 7.35156 2.25C7.68395 2.92045 7.85014 3.71591 7.85014 4.63636ZM6.82742 4.63636C6.82742 3.88068 6.70099 3.2429 6.44815 2.72301C6.19815 2.20312 5.85866 1.80966 5.42969 1.54261C5.00355 1.27557 4.52628 1.14205 3.99787 1.14205C3.46946 1.14205 2.99077 1.27557 2.56179 1.54261C2.13565 1.80966 1.79616 2.20312 1.54332 2.72301C1.29332 3.2429 1.16832 3.88068 1.16832 4.63636C1.16832 5.39205 1.29332 6.02983 1.54332 6.54972C1.79616 7.0696 2.13565 7.46307 2.56179 7.73011C2.99077 7.99716 3.46946 8.13068 3.99787 8.13068C4.52628 8.13068 5.00355 7.99716 5.42969 7.73011C5.85866 7.46307 6.19815 7.0696 6.44815 6.54972C6.70099 6.02983 6.82742 5.39205 6.82742 4.63636Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgQuestion;
